import { render, staticRenderFns } from "./PlayerStartInfoPage.vue?vue&type=template&id=069af6e6&scoped=true&"
import script from "./PlayerStartInfoPage.vue?vue&type=script&lang=js&"
export * from "./PlayerStartInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStartInfoPage.vue?vue&type=style&index=0&id=069af6e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069af6e6",
  null
  
)

export default component.exports